'use client';

import cx from 'classnames';
import type React from 'react';
import styles from './styles.module.css';

export type TabItem = {
  title: string;
  value: string;
};

type TabsProps = {
  tabs: TabItem[];
  activeTab: string;
  onTabChange: (value: string) => void;
  className?: string;
  variant?: 'default' | 'entity-selector';
  onChangeCallback?: () => void;
  isMobile?: boolean;
};

const Tabs: React.FC<TabsProps> = ({
  tabs,
  activeTab,
  onTabChange,
  className = '',
  variant = 'default',
  onChangeCallback,
  isMobile = false,
}) => {
  if (variant === 'entity-selector' && isMobile) {
    return (
      <fieldset className={cx(styles.selectMobile, className)}>
        {tabs.map((tab) => (
          <label key={tab.value}>
            <input
              className={styles.entitySelectorInput}
              type="radio"
              name={tab.value}
              value={tab.value}
              checked={activeTab === tab.value}
              onChange={() => {
                onTabChange(tab.value);
                if (onChangeCallback) onChangeCallback();
              }}
            />
            <span
              className={cx(styles.entitySelectorText, styles.mobileEntity)}
            >
              {tab.title}
            </span>
          </label>
        ))}
      </fieldset>
    );
  } else if (variant === 'entity-selector') {
    return (
      <fieldset className={`${styles.entitySelector} ${className}`}>
        {tabs.map((tab) => (
          <label key={tab.value} className={styles.entitySelectorLabel}>
            <input
              className={styles.entitySelectorInput}
              type="radio"
              name={tab.value}
              value={tab.value}
              checked={activeTab === tab.value}
              onChange={() => {
                onTabChange(tab.value);
                if (onChangeCallback) onChangeCallback();
              }}
            />
            <span className={styles.entitySelectorText}>{tab.title}</span>
          </label>
        ))}
      </fieldset>
    );
  }

  if (isMobile) {
    return (
      <ul className={`${styles.tabsMobile}`}>
        {tabs.map((tab) => (
          <li key={tab.value}>
            <button
              className={`${styles.tabsMobileBtn} ${
                activeTab === tab.value
                  ? styles.tabsMobileActive
                  : styles.tabsMobileInactive
              }`}
              onClick={() => onTabChange(tab.value)}
            >
              <div>{tab.title}</div>
            </button>
          </li>
        ))}
      </ul>
    );
  }
  return (
    <ul className={`${styles.tabsList} ${className}`}>
      {tabs.map((tab) => (
        <li key={tab.value} className={styles.tabsItem}>
          <button
            className={`${styles.tabsButton} ${
              activeTab === tab.value ? styles.active : ''
            }`}
            onClick={() => onTabChange(tab.value)}
          >
            <div>{tab.title}</div>
          </button>
        </li>
      ))}
    </ul>
  );
};

export default Tabs;
